import type en from '../en/monitoring'
import type { Translation } from '../types'

/** Monitoring and alerts */
const monitoring: Translation<typeof en> = {
  "monitoring.subtitle": "Estado en tiempo real de todos los sitios",
  "monitoring.online": "En línea",
  "monitoring.warning": "Advertencia",
  "monitoring.offline": "Sin conexión",
  "monitoring.awaitingVpn": "Esperando VPN",
  "monitoring.noData": "Sin datos",
  "monitoring.lastSeen": "Visto por última vez {when}",
  "monitoring.alertsActive": { one: "{count} alerta activa", other: "{count} alertas activas" },
  "monitoring.alertsResolved": { one: "{count} alerta resuelta", other: "{count} alertas resueltas" },
  "monitoring.active": "Activas",
  "monitoring.resolved": "Resueltas",
  "monitoring.noResolved": "No hay alertas resueltas",
  "monitoring.allClear": "¡Todo en orden!",
  "monitoring.noneResolvedYet": "Todavía no se ha resuelto ninguna alerta.",
  "monitoring.healthy": "No hay alertas activas — su red funciona bien.",
  "monitoring.acknowledge": "Confirmar",
  "monitoring.acknowledged": "✓ Confirmada",
  "monitoring.resolvedWhen": "✓ Resuelta {when}",
  "monitoring.category.VPN": "VPN",
  "monitoring.category.cellular": "móvil",
  "monitoring.category.device": "dispositivo",
  "monitoring.category.firmware": "firmware",
  "monitoring.category.license": "licencia",
  "monitoring.category.link": "enlace",
  "monitoring.category.speedfusion": "speedfusion",
  "monitoring.category.sync": "sincronización",
  "monitoring.category.wan": "wan",
  "monitoring.category.wifi": "wi-fi",
}

export default monitoring
